module.exports = __webpack_public_path__ + "img/1.e5871b0d.png";